<template>
  <div>
    <div class="carousel_wrap">
      <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 联系我们 -->
    <div class="contact">
      <div class="contact-container">
        <h2>联系我们</h2>
        <h3>不管是什么，我们很高兴收到您的来电</h3>
        <ul>
          <li v-for="(item, index) in contacts" :key="index">
            <img :src="item.img" loading="lazy" />
            <div
              v-for="(contact, index) in item.content"
              :key="index"
              class="contact-list"
            >
              <div>
                <span v-if="contact.title">{{ contact.title }}</span>
                <span v-if="contact.content">{{ contact.content }}</span>
                <span v-if="contact.tips">{{ contact.tips }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="address">
      <div class="address-left">
        <h2>{{ address.company }}</h2>
        <p>{{ address.address1 }}</p>
        <p>{{ address.address2 }}</p>
        <!-- <pre>{{address.address3}}</pre> -->
      </div>
      <div class="address-right" id="baidu-container"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerList: [],
      contacts: [],
      address: {}
    }
  },
  created() {
    this.initData()


  },
  mounted() {
    var map = new BMapGL.Map("baidu-container");          // 创建地图实例 
    var point = new BMapGL.Point(113.270419, 22.913462);  // 创建点坐标 
    map.centerAndZoom(point, 15);                 // 初始化地图，设置中心点坐标和地图级别
    // map.setHeading(64.5);   //设置地图旋转角度
    // map.setTilt(73);       //设置地图的倾斜角度
    map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    var marker = new BMapGL.Marker(point);        // 创建标注   
    map.addOverlay(marker);                     // 将标注添加到地图中
  },
  methods: {
    initData() {
      const baseUrl = process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_PUBLIC_PATH
        : '/'

      fetch(baseUrl + '/contact/data.json')
        .then(response => response.json())
        .then(data => {
          let { banners, contacts, address } = data
          this.bannerList = banners
          this.contacts = contacts
          this.address = address
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}

.contact {
  width: 100%;
  background: url("../../assets/img/14.dfc68f4.png") 0 0 no-repeat;
  background-size: cover;
}
.contact-container {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    margin-top: 105px;
    margin-bottom: 15px;
  }
  h3 {
    margin-bottom: 50px;
  }
  > ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
    }
    li {
      list-style: none;
      border: 1px solid gray;
      border-radius: 10px;

      width: 320px;
      height: 450px;
      margin-bottom: 20px;
      margin-right: 38px;

      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      padding-top: 40px;
      @media screen and (max-width: 768px) {
        height: 250px;
      }
      > img {
        width: 100px;
        height: 100px;
      }
      > h4 {
        margin-top: 10px;
        margin-bottom: 10px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        line-height: 48px;
      }
      .contact-list {
        margin-top: 50px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: left;
        font-size: 20px;
        > div {
          width: 100%;
          display: flex;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 1em;
          // line-height: 48px;
          span {
            display: inline-block;
            min-width: 70px;
          }
        }

        @media screen and (max-width: 768px) {
          margin-top: 10px;
          > div {
            font-size: 12px;
          }
        }
      }
    }
  }
}
.address {
  width: 80%;
  margin: 100px auto;
  display: flex;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 90%;
  }
  .address-left {
    flex: 1.5;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 24px;
    color: #666666;
    line-height: 48px;
    @media screen and (max-width: 768px) {
      font-size: 12px;
      p {
        line-height: 1.2em;
      }
    }
  }
  .address-right {
    flex: 1;
  }
  h2 {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 48px;
    color: #0160fd;
    line-height: 48px;
    margin-bottom: 30px;
    @media screen and (max-width: 768px) {
      font-size: 18px;
      margin-bottom: 10px;
    }
  }
}

#baidu-container {
  width: 100%;
  height: 500px;

  @media screen and (max-width: 768px) {
    min-height: 200px;
    margin-top: 10px;
  }
}
</style>